// extracted by mini-css-extract-plugin
module.exports = {"relative":"Transfer_relative_1y8g5"};